import { createContext, useContext, ReactNode } from 'react';
import { CheckoutDataWithAddresses, UseCheckoutResult } from '../types';
import { useCheckout as useCheckoutHook } from '../hooks/useCheckout';

const CheckoutContext = createContext<UseCheckoutResult | null>(null);

export function CheckoutProvider({
  children,
  initialData,
}: {
  children: ReactNode;
  initialData?: CheckoutDataWithAddresses;
}) {
  const { checkoutData: fetchedData, loading, error } = useCheckoutHook();
  const checkoutData = initialData || fetchedData;

  return (
    <CheckoutContext.Provider value={{ checkoutData, loading, error }}>
      {children}
    </CheckoutContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useCheckout() {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('useCheckout must be used within a CheckoutProvider');
  }
  return context;
}
